import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';

import * as actions from '../actions';

import SideBarMenu from './SideBarMenu';
import PrevNext from './PrevNext';

import Step1 from './krw-steps/Step1';
import Step2 from './krw-steps/Step2';
import Step3 from './krw-steps/Step3';
import Step4 from './krw-steps/Step4';
import Step5 from './krw-steps/Step5';
import Step6 from './krw-steps/Step6';
import Step7 from './krw-steps/Step7';
import Download from './download/Download';
import {KRW_STEPS} from "../constants/steps";


class Krw extends Component {

    componentDidMount() {
        const breadCrumbSecond = `${this.props.translate('BREADCRUMBS.sortiment')} ${this.props.translate('BREADCRUMBS.krw')}`;
        const breadCrumbThird = this.props.translate('BREADCRUMBS.model');

        this.props.setBreadCrumbs(breadCrumbSecond, breadCrumbThird);

        // set articleID
        this.props.setArticle(this.props.articleID);
    }

    componentDidUpdate() {
        const checkZ = this.isZ(this.props.zValue);
        if(!checkZ){
            this.props.setFlanges();
        }
    }

    isZ(z){
        if(z) {
            const makeNum = parseInt(z);
            if (z && makeNum === 0) {
                return false
            }
        }
        return true
    }

    renderConfig() {

        const breadCrumbSecond = `${this.props.translate('BREADCRUMBS.sortiment')} ${this.props.translate('BREADCRUMBS.krw')}`;
        this.props.setBreadCrumbs(breadCrumbSecond);

        switch (this.props.step) {
            case 1:
                return <Step1 articleID={this.props.articleID} />;
            case 2:
                return <Step2 article='krw' articleID={this.props.articleID} />;
            case 3:
                return <Step3 articleID={this.props.articleID} />;
            case 4:
                return <Step4  articleID={this.props.articleID} />;
            case 5:
                return <Step5  articleID={this.props.articleID} />;
            case 6:
                return <Step6 articleID={this.props.articleID} />;
            case 7:
                return <Step7 articleID={this.props.articleID} />;
            case 8:
                return <Download  article='krw' articleID={this.props.articleID} />;
            default:
                return <div>THIS IS ERROR!!!</div>

        }
    };

    render() {
        return (
            <div className='row configurator-container'>
                <div className='col s12 m3 div-menu-col' style={{overflow: 'auto'}}>
                    <div className='div-menu'>
                        <div className='vertical-line'></div>
                        <div className='above-first-step'></div>
                        <SideBarMenu
                            stepList={this.props.allSteps ? this.props.allSteps : KRW_STEPS}
                            field='KRW'
                            lastStep={10} />
                        <div className='below-last-step'></div>
                    </div>
                </div>
                <div className='col s12 m9 step-col'>
                    <div className='step-container'>
                        {this.renderConfig()}
                        <PrevNext divClass='col s12' currentStep={this.props.step} lastStep={10} />
                    </div>
                </div>
            </div>
        );
    }

};

/**
 * Prop types
 * @type {{step: *}}
 */
Krw.propTypes = {
    step:           PropTypes.number.isRequired,
    setBreadCrumbs: PropTypes.func.isRequired,
    translate:      PropTypes.func.isRequired,
};

function mapStateToProps({steps, locale, krw}) {
    return {
        step:      steps.currentStep,
        allSteps: steps.allSteps,
        translate: getTranslate(locale),
    };
}

export default connect(mapStateToProps, actions)(Krw);



// WEBPACK FOOTER //
// ./src/components/Krw.js